import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import i18next from 'i18next';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  year!: number;

  constructor(public dialog: MatDialog) {}

  ngOnInit() {
    this.year = new Date().getFullYear();
  }

  /**
   * Open support text modal
   */
  openSupportModal(): void {
    this.dialog.open(FeedbackModalComponent, {
      width: '600px',
      data: {
        text: i18next.t('supportMsg'),
        close: true,
        theme: 'dark'
      }
    });
  }

  onFooterClick(option: string) {
    let documentPath = 'assets/documents/Nota Legal.pdf';
    let name = 'Nota Legal.pdf';
    switch (option) {
      case 'privacy':
        documentPath = 'assets/documents/Política de privacidad.pdf';
        name = 'Política de privacidad.pdf';
        break;
      case 'cookies':
        documentPath = 'assets/documents/Politica de Cookies.pdf';
        name = 'Politica de Cookies.pdf';
        break;
    }
    const a = document.createElement('a');
    a.href = documentPath;
    a.download = name;
    a.click();
  }
}
